module.exports = __webpack_public_path__ + "static/media/licenta1.5e224451.png";